import type { TStatusOption } from "../statuses/consts";
import { headerHeight } from "../../globals";
import type { TStatus } from "../statuses/statusLogic";
import { tryShowFormattedLogo } from "./ColumnHeaderProduct/helpers";

type SelectOption<T> = { value: T; label?: string } | null;

export function SelectPrettyValue({
  renderValueParams,
  logo,
  options,
  selectHeightPx = headerHeight,
}: {
  renderValueParams: SelectOption<string> | null;
  logo: string | undefined;
  options: TStatusOption[];
  selectHeightPx?: number;
}) {
  if (!renderValueParams) return null;
  const option = options.find((opt) => opt.value === renderValueParams.value);

  const formattedLogo = tryShowFormattedLogo(option, logo);
  return (
    <div
      className="flex justify-center items-center w-full"
      style={{
        ...option?.style,
        height: selectHeightPx,
      }}
    >
      {formattedLogo && <img style={{ height: "14px", width: "14px" }} alt="logo" src={formattedLogo} />}
      {option?.icon && <option.icon />}
      {option?.label && (
        <span
          className="text-xs"
          style={{
            paddingLeft: formattedLogo ? "4px" : "0px",
            fontWeight: formattedLogo ? "normal" : "bold",
          }}
        >
          {option?.label}
        </span>
      )}
    </div>
  );
}

type TStatusSelectOption = TStatusOption & {
  artisLogo: string | undefined;
  value: TStatus;
  statusOptionsToRender: TStatusOption[];
};

export function SelectPrettyOption(option: TStatusSelectOption) {
  const { statusOptionsToRender } = option;
  const isVisible = statusOptionsToRender.some((renderOption) => renderOption.value === option.value);

  const formattedLogo = tryShowFormattedLogo(option, option.artisLogo);

  return (
    <option
      value={option.value}
      className="flex justify-center items-center h-full gap-1 text-ellipsis"
      style={{
        ...option?.style,
        display: isVisible ? "flex" : "none",
      }}
    >
      {formattedLogo && (
        <img
          style={{
            height: "14px",
            width: "14px",
          }}
          alt="logo"
          src={formattedLogo}
        />
      )}
      {option?.icon && <option.icon />}
      <span className="text-xs">{option.label}</span>
    </option>
  );
}
